module.exports = __webpack_public_path__ + "img/rank2_2.28da075b.png";